import classNames from 'classnames'
import React from 'react'
import { NavLink } from 'react-router-dom'

export default function ButtonAuth({classBtnLogin,classBtnRegister,classname}) {
  return (
    <div className={classNames('flex gap-3 ',classname)}>
        <NavLink to={'/login'} className={classNames('border-[1px] border-[#ffffff59] px-5 py-2 rounded-full  md:hover:bg-gray-100 md:hover:text-black md:transition-all',classBtnLogin)}>Log in</NavLink>
        <NavLink to={'/register'} className= {classNames('border-[1px] border-[#ffffff59] px-5 py-2 rounded-full  md:hover:bg-gray-100 md:hover:text-black md:transition-all',classBtnRegister)}>Sign up</NavLink>
    </div>
  )
}
